import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const targetPosition = element.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Master Ankit Raval</h3>
            <p>Guiding souls through cosmic wisdom for over 10 years</p>
            <div className="social-links">
              <a href="https://share.google/RSpvyr0iWqHyslFjs"><i className="fab fa-google"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-youtube"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><button onClick={() => scrollToSection('home')}>Home</button></li>
              <li><button onClick={() => scrollToSection('about')}>About</button></li>
              <li><button onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button onClick={() => scrollToSection('events')}>Events</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><button onClick={() => scrollToSection('services')}>Birth Chart Reading</button></li>
              <li><button onClick={() => scrollToSection('services')}>Love Compatibility</button></li>
              <li><button onClick={() => scrollToSection('services')}>Career Guidance</button></li>
              <li><button onClick={() => scrollToSection('services')}>Gemstone Consultation</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p><i className="fas fa-phone"></i> +91 8160569755</p>
            <p><i className="fas fa-envelope"></i> info@astrovastukstar.com</p>
            <p><i className="fas fa-map-marker-alt"></i> Ahmedabad, Gujarat</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Master Ankit Raval - Kstarplanetary. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;